var exports = {
  "iU": "Message.module__message___QlBaan",
  "Ph": "Message.module__messagePreviewSpacing___QlBaan",
  "IL": "Message.module__messagePreview___QlBaan",
  "Xo": "Message.module__messageHovered___QlBaan",
  "uK": "Message.module__focusRingAnchor___QlBaan",
  "J8": "Message.module__messageCompact___QlBaan",
  "L8": "Message.module__messageMentioned___QlBaan",
  "m6": "Message.module__messageReplying___QlBaan",
  "O6": "Message.module__messageHighlight___QlBaan",
  "lY": "Message.module__contextMenuActive___QlBaan",
  "Bc": "Message.module__mobileLayout___QlBaan",
  "p2": "Message.module__messageLongPress___QlBaan",
  "Uw": "Message.module__messageGrouped___QlBaan",
  "kT": "Message.module__messageEditing___QlBaan",
  "E4": "Message.module__messageSent___QlBaan",
  "mr": "Message.module__messageSending___QlBaan",
  "b$": "Message.module__messageFailed___QlBaan",
  "RZ": "Message.module__failedFooter___QlBaan",
  "Iu": "Message.module__failedFooterMessage___QlBaan",
  "bg": "Message.module__failedFooterLabel___QlBaan",
  "OZ": "Message.module__failedFooterIcon___QlBaan",
  "dv": "Message.module__failedRetryIcon___QlBaan",
  "QW": "Message.module__failedRetryButton___QlBaan",
  "q5": "Message.module__messageGutterLeft___QlBaan",
  "ZN": "Message.module__messageGutterRight___QlBaan",
  "$7": "Message.module__messageAvatar___QlBaan",
  "CW": "Message.module__messageNoText___QlBaan",
  "U7": "Message.module__messageContent___QlBaan",
  "rO": "Message.module__messageAuthorInfo___QlBaan",
  "xW": "Message.module__jumpHeading___QlBaan",
  "RO": "Message.module__jumpHeadingButton___QlBaan",
  "dw": "Message.module__messageAuthorRow___QlBaan",
  "AY": "Message.module__messageAuthorPart___QlBaan",
  "x": "Message.module__userTagOffset___QlBaan",
  "oL": "Message.module__messageTimestamp___QlBaan",
  "BK": "Message.module__authorDashSeparator___QlBaan",
  "um": "Message.module__messageUsername___QlBaan",
  "Lo": "Message.module__messageText___QlBaan",
  "L5": "Message.module__messageTimestampCompact___QlBaan",
  "tQ": "Message.module__compactAuthorPrefix___QlBaan",
  "U6": "Message.module__copyOnly___QlBaan",
  "Mz": "Message.module__compactInlineContent___QlBaan",
  "aM": "Message.module__systemMessageContent___QlBaan",
  "vp": "Message.module__contextMenuUnderline___QlBaan",
  "aE": "Message.module__messageTimeoutIndicator___QlBaan",
  "t4": "Message.module__textSeparator___QlBaan",
  "KL": "Message.module__messageTimestampHover___QlBaan",
  "jh": "Message.module__messageTimestampCompactHover___QlBaan",
  "iZ": "Message.module__messageAvatarCompact___QlBaan",
  "kq": "Message.module__compactContentWrapper___QlBaan",
  "xv": "Message.module__hoverAction___QlBaan",
  "kL": "Message.module__container___QlBaan",
  "tI": "Message.module__repliedMessage___QlBaan",
  "_T": "Message.module__repliedMessageCompact___QlBaan",
  "$y": "Message.module__repliedTextPreview___QlBaan",
  "NL": "Message.module__repliedAvatar___QlBaan",
  "a3": "Message.module__repliedIconContainer___QlBaan",
  "Pq": "Message.module__repliedIcon___QlBaan",
  "EK": "Message.module__repliedUsername___QlBaan",
  "IQ": "Message.module__repliedItalic___QlBaan",
  "t": "Message.module__unstyled___QlBaan",
  "Io": "Message.module__repliedTextContent___QlBaan",
  "c": "Message.module__systemMessageFollowsSystem___QlBaan",
  "Hj": "Message.module__systemMessageIconWrapper___QlBaan",
  "Po": "Message.module__systemMessageIconCompact___QlBaan",
  "jJ": "Message.module__systemMessageTimestamp___QlBaan",
  "rc": "Message.module__systemMessageContentWrapper___QlBaan",
  "V_": "Message.module__systemMessageCompactContent___QlBaan",
  "Gq": "Message.module__systemMessageIconSvg___QlBaan",
  "hr": "Message.module__systemMessageLink___QlBaan",
  "ll": "Message.module__userTagCompact___QlBaan",
  "O4": "Message.module__editedTimestamp___QlBaan",
  "k8": "Message.module__editedLabel___QlBaan",
  "zX": "Message.module__typingContainer___QlBaan",
  "Y9": "Message.module__typingCluster___QlBaan",
  "RL": "Message.module__typingIndicator___QlBaan",
  "Kl": "Message.module__typingAvatarContainer___QlBaan",
  "tY": "Message.module__typingText___QlBaan",
  "AZ": "Message.module__typingClusterComposerStatus___QlBaan",
  "am": "Message.module__compactContentNoPrefix___QlBaan",
  "Ys": "Message.module__compactBody___QlBaan",
  "Ac": "Message.module__unknownMessageCompactContent___QlBaan",
  "qU": "Message.module__unknownMessageWarning___QlBaan",
  "NG": "Message.module__keyboardFocused___QlBaan",
  "an": "Message.module__messageClientSystem___QlBaan",
  "og": "Message.module__systemMessageContainer___QlBaan",
  "Is": "Message.module__systemMessageIcon___QlBaan",
  "ry": "Message.module__mediaFocusRing___QlBaan",
  "xS": "Message.module__systemMessageDismissButton___QlBaan",
  "Eu": "Message.module__silentMessageIcon___QlBaan",
};

module.exports = exports;
